<template>
   <div class="body">
        <div class="main">
            <div class="title">{{title}}</div>
            <div class="from">
                <span>来源:</span><span>{{from}}</span><span>{{time}}</span>
            </div>
          
            <div class="content">
            <div class="content-img"> <img :src="content" alt=""></div>
            
            <div class="end-gif">
              <img :src="endPic" alt="">
            </div>
        </div>
    </div>
   </div>
</template>

<script>
import api from "@/api/api.js";
export default {
data(){
    return{
       title:'行车故障不用急，紫金保险来帮你！',
        from:'原创',
        time:'2020-05-19  15:46',
        content:api.imgAllUrl+ "/break_content.jpg",
        endPic:api.imgAllUrl+ "/break_end.gif",
    }
}
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.body{
    width: 100%;
    min-height: 6rem;
    margin-bottom: 0.2rem;
    background: white;
    .main{
    width: 100%;
    height: 100%;
     box-sizing: border-box;
    padding: 0.1rem;
        .title{
            width:100%;
            height: 0.4rem;
            font-size: 0.2rem;
            line-height: 0.3rem;
            color: #333333;
            opacity: 1;
        }
    .from{
            width:100%;
            height: 0.22rem;
            font-size: 0.15rem;
        span:nth-child(1){
            font-size: 0.15rem;
            font-weight: 400;
            line-height: 0.25rem;
            color: #999999;
            opacity: 1;
            } 
            span:nth-child(2){
            font-size: 0.15rem;
            font-weight: 400;
            line-height: 0.25rem;
            color: #815DC4;
            opacity: 1;
            margin-left: 0.1rem;
            }
        span:nth-child(3){  
            font-size: 0.15rem;
            font-weight: 400;
            line-height: 0.25rem;
            color: #999999;
            opacity: 1;
            margin-left: 0.15rem;
        } 
      }
      .content{
          margin-top: 0.4rem;
          width: 100%;
          height: 100%;
          .content-img{
              width: 100%;
              height: 100%;
              padding: 0.05rem;
              box-sizing: border-box;
                    img{
                        width: 100%;
                        height: 100%;
                        display:block
                    }
          }
         
      }
      .end-gif{
          margin-top: 0.2rem;
          width: 100%;
          height: 2.15rem;
          img{width: 100%;height: 100%;}
      }
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/Info/Break.vue